import "@fortawesome/fontawesome-free/css/all.min.css";
import { useState } from "react";
import { createBrowserRouter, Outlet, RouterProvider } from "react-router-dom";
// import Home from "./Home";
// import Login from "./pages/login/Login.tsx";
// import { AuthContext } from "./context/AuthContext.js";
// import NotFoundPage from './pages/pagenotfound/NotFoundPage'
import "../src/assets/styles/globalStyle.scss";
import NotFoundPageOne from "./pages/pagenotfound/NotFoundPageOne.js";
import "moment/locale/fr";

import { Box, Stack } from "@mui/material";
import Footer from "./component/footer/Footer.js";
import LeftSide from "./component/leftside/LeftSide.js";
import NavBar from "./component/navbar/NavBar.tsx";
import RetardEleve from "./pages/RetardEleve.tsx";
import RetardPersonnel from "./pages/RetardPersonnel.tsx";
import Finance from "./pages/Finance.js";

import RessourceList from "./component/ressources/ressource/RessourceList.js";
import RessourceListPublished from "./component/ressources/partage/RessourceList.js";
import RessourceListPublishedNot from "./component/ressources/partageNot/RessourceList.js";
import Paiement from "./pages/paiement/Paiement.tsx";
import { PaiementDetail } from "./pages/PaiementDetail.tsx";
import "./index.css";
import SideBar from "./pages/SideBar.tsx";
import NotFoundPage from "./pages/pagenotfound/NotFoundPage.js";
import Profil from "./pages/identity/index.tsx";
import Configuration from "./pages/configuration/index.js";
import Communique from "./pages/communique/index.tsx";
import "./assets/styles/darkStyle.scss";
import Ressource from "./pages/Ressource.js";
import Scolarite from "./pages/configuration/scolarite/index.tsx";
import Ponctualite from "./pages/configuration/ponctualite/index.tsx";
import FraisScolaire from "./pages/configuration/frais/index.tsx";
import Grade from "./pages/configuration/gradeFonction/index.tsx";
import Depense from "./pages/configuration/depense/index.tsx";
import Terminal from "./pages/configuration/terminal/index.tsx";
import CommuniqueConfig from "./pages/configuration/communique/index.tsx";
import Eleve from "./pages/configuration/eleve/index.tsx";
import Personnel from "./pages/configuration/personnel/index.tsx";
import EleveInfo from "./pages/configuration/eleve/singleInfo/EleveInfo.tsx";
import ParentInfo from "./pages/configuration/parent/singleInfo/ParentInfo.tsx";
import PersonnelInfo from "./pages/configuration/personnel/singleInfo/PersonnelInfo.tsx";
import ParcoursInfo from "./pages/configuration/personnel/singleInfo/ParcoursInfo.tsx";
import EleveList from "./pages/_eleve/EleveList.tsx";
import PersonnelList from "./pages/personnel/PersonnelList.tsx";
import Parent from "./pages/configuration/parent/index.tsx";
import ParentAddress from "./pages/configuration/parent/singleInfo/ParcoursInfo.tsx";
import ParentInfoEleve from "./pages/configuration/eleve/singleInfo/ParentInfoEleve.tsx";
import CompteInfo from "./pages/configuration/personnel/singleInfo/CompteInfo.tsx";
import Log from "./pages/login/Log.tsx";
import Menus from "./component/_elements/Menus.tsx";
import Dashboard from "./pages/_dashboard/Dashboad.tsx";
import Student from "./pages/_eleve/Student.tsx";
import SingleStudent from "./pages/_singleStudent/SingleStudent.tsx";
import NewStudent from "./pages/_singleStudent/NewStudent.tsx";
import Attendance from "./pages/_attendance/Attendance.tsx";
import Payment from "./pages/_payment/Payment.tsx";
import Message from "./pages/_message/Message.tsx";
import Admin from "./pages/_profil/Admin.tsx";
import Parametre from "./pages/_parametre/Parametre.tsx";
import ConnexionErrorPage from "./pages/_connexionError/ConnexionError.tsx";
import ProtectedRoute from "./component/_elements/ProtectedRoute.tsx";
import Unauthorized from "./pages/_unauthorized/Unauthorized.tsx";
import { RequireAuth } from "./component/_elements/RequireAuth.tsx";

type Props = {
  children: JSX.Element;
};

const App = () => {
  const darkMode = false;
  const [isDarkMode, setIsDarkMode] = useState(true);

  // const { currentUser } = useContext(AuthContext);

  // const RequireAuth = ({ children }: Props) => {
  //   return currentUser ? children : <Navigate to="/login" />;
  // };

  const Layout = () => {
    return (
      <div className={darkMode ? "dark" : ""}>
        <Box className="d_body">
          {/* <NavBar className="d_navBar" /> */}
          <NavBar />
          <Stack
            direction="row"
            spacing={0}
            justifyContent=""
            sx={{ position: "relative" }}
          >
            <LeftSide />
            {/* CONTENT */}
            <Outlet />
          </Stack>
          <Footer />
        </Box>
      </div>
    );
  };

  const router = createBrowserRouter([
    {
      path: "/",
      element: (
        <ProtectedRoute>
          <Layout />
        </ProtectedRoute>
      ),
      children: [
        {
          path: "",
          element: <SideBar />,
        },
        {
          path: "retard-eleve",
          element: <RetardEleve />,
        },
        {
          path: "retard-personnel",
          element: <RetardPersonnel />,
        },
        {
          path: "paiement/eleve/:id",
          element: <PaiementDetail />,
        },
        {
          path: "paiement",
          element: <Paiement />,
        },
        {
          path: "finance",
          element: <Finance />,
        },
        {
          path: "ressource",
          element: <Ressource />,
        },
        {
          path: "all-ressources",
          element: <RessourceList />,
        },
        {
          path: "published-ressources",
          element: <RessourceListPublished />,
        },
        {
          path: "no-puplished-ressources",
          element: <RessourceListPublishedNot />,
        },
        {
          path: "communique",
          element: <Communique />,
        },
        {
          path: "identity",
          element: <Profil />,
        },
        {
          path: "configuration",
          element: <Configuration />,
          children: [
            {
              path: "configuration",
              element: <Scolarite />,
            },
            {
              path: "ponctualite",
              element: <Ponctualite />,
            },
            {
              path: "frais",
              element: <FraisScolaire />,
            },
            {
              path: "grade-et-fonction",
              element: <Grade />,
            },
            {
              path: "terminal",
              element: <Terminal />,
            },
          ],
        },
        {
          path: "eleves",
          element: <EleveList />,
          children: [
            { path: "", element: <EleveInfo /> },
            { path: "parent-info", element: <ParentInfoEleve /> },
          ],
        },
        {
          path: "personnels",
          element: <PersonnelList />,
          children: [
            {
              path: "",
              element: <PersonnelInfo />,
            },
            { path: "parcours-info", element: <ParcoursInfo /> },
          ],
        },
        {
          path: "config-eleve-info",
          element: <Eleve />,
          children: [
            { path: "", element: <EleveInfo /> },
            { path: "parent-info", element: <ParentInfoEleve /> },
          ],
        },
        {
          path: "config-personnel-info",
          element: <Personnel />,
          children: [
            { path: "", element: <PersonnelInfo /> },
            { path: "parcours-info", element: <ParcoursInfo /> },
            { path: "compte-info", element: <CompteInfo /> },
          ],
        },
        {
          path: "config-parent-info",
          element: <Parent />,
          children: [
            { path: "", element: <ParentInfo /> },
            { path: "parcours-info", element: <ParentAddress /> },
          ],
        },
      ],
    },
    {
      path: "/login",
      // element: <Login />,
      element: <Log />,
    },
    {
      path: "*",
      element: <NotFoundPageOne />,
    },
  ]);

  const Layout2 = () => {
    return (
      <div
        className={`min-h-screen ${
          isDarkMode ? "bg-[#0D1117] text-white" : "bg-white text-gray-800"
        }`}
      >
        <div className="flex">
          {/* Sidebar */}
          <Menus isDarkMode={isDarkMode} />
          {/* Main Content */}
          <Outlet context={{ isDarkMode, setIsDarkMode }} />
        </div>
      </div>
    );
  };

  const router2 = createBrowserRouter([
    {
      path: "/",
      element: (
        <RequireAuth>
          <Layout2 />
        </RequireAuth>
      ),
      children: [
        {
          path: "",
          // element: <SideBar />,
          element: <Dashboard />,
        },
        {
          // path: "retard-eleve",
          // element: <RetardEleve />,
          path: "attendance",
          element: <Attendance />,
        },
        //*******Attendance for Personnel is put in new Attendance link above******
        // {
        //   path: "retard-personnel",
        //   element: <RetardPersonnel />,
        // },
        {
          path: "paiement",
          element: <Payment />,
          // element: <Paiement />,
        },
        {
          path: "message",
          element: (
            <ProtectedRoute
              allowedRoles={[
                "SuperAdministrateur",
                "Administrateur",
                "Comptable",
              ]}
            >
              <Message />,
            </ProtectedRoute>
          ),
          // path: "communique",
          // element: <Communique />,
        },
        {
          path: "profil",
          element: <Admin />,
          // path: "identity",
          // element: <Profil />,
        },

        {
          path: "parametre",
          element: (
            <ProtectedRoute
              allowedRoles={[
                "SuperAdministrateur",
                "Administrateur",
                "Comptable",
              ]}
            >
              <Parametre />,
            </ProtectedRoute>
          ),
          // element: <Param />,
          // path: "configuration",
          // element: <Configuration />,
          // children: [
          //   {
          //     path: "configuration",
          //     element: <Scolarite />,
          //   },
          //   {
          //     path: "ponctualite",
          //     element: <Ponctualite />,
          //   },
          //   {
          //     path: "frais",
          //     element: <FraisScolaire />,
          //   },
          //   {
          //     path: "grade-et-fonction",
          //     element: <Grade />,
          //   },
          //   {
          //     path: "terminal",
          //     element: <Terminal />,
          //   },
          // ],
        },
        {
          path: "paiement/eleve/:id",
          element: (
            <ProtectedRoute
              allowedRoles={[
                "SuperAdministrateur",
                "Administrateur",
                "Comptable",
              ]}
            >
              <PaiementDetail />,
            </ProtectedRoute>
          ),
        },
        {
          path: "finance",
          element: <Finance />,
        },
        {
          path: "ressource",
          element: <Ressource />,
        },
        {
          path: "all-ressources",
          element: <RessourceList />,
        },
        {
          path: "published-ressources",
          element: <RessourceListPublished />,
        },
        {
          path: "no-puplished-ressources",
          element: <RessourceListPublishedNot />,
        },

        {
          path: "eleves",
          // element: <EleveList />,
          element: <Student />,
          // children: [
          //   { path: "", element: <EleveInfo /> },
          //   { path: "parent-info", element: <ParentInfoEleve /> },
          // ],
        },

        {
          path: "eleves/:slug",
          element: <SingleStudent />,
        },
        {
          path: "eleves/nouveau",
          element: <NewStudent />,
        },
        // {
        //   path: "personnels",
        //   element: <PersonnelList />,
        //   children: [
        //     {
        //       path: "",
        //       element: <PersonnelInfo />,
        //     },
        //     { path: "parcours-info", element: <ParcoursInfo /> },
        //   ],
        // },
        {
          path: "config-eleve-info",
          element: <Eleve />,
          children: [
            { path: "", element: <EleveInfo /> },
            { path: "parent-info", element: <ParentInfoEleve /> },
          ],
        },
        {
          path: "config-personnel-info",
          element: <Personnel />,
          children: [
            { path: "", element: <PersonnelInfo /> },
            { path: "parcours-info", element: <ParcoursInfo /> },
            { path: "compte-info", element: <CompteInfo /> },
          ],
        },
        {
          path: "config-parent-info",
          element: <Parent />,
          children: [
            { path: "", element: <ParentInfo /> },
            { path: "parcours-info", element: <ParentAddress /> },
          ],
        },
      ],
    },
    {
      path: "/login",
      // element: <Login />,
      element: <Log />,
    },
    {
      path: "unauthorized",
      element: <Unauthorized />,
    },
    {
      path: "/network-error",
      // element: <Login />,
      element: <ConnexionErrorPage />,
    },

    {
      path: "*",
      element: <NotFoundPageOne />,
    },
  ]);

  // return <RouterProvider router={router} />;
  return <RouterProvider router={router2} />;
};

export default App;
